import { IObj } from '../entity.js'

export interface ObjOptions extends Omit<Partial<IObj>, 'typeOf' | 'entityType'> {
  // Reserved for future object-specific options
  // [key: string]: unknown
}

export interface InstanceObjOptions extends ObjOptions {
  instanceOf: string
}
